// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_Email from "../Ouroboros.Models.Brands.Email/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_FirstName from "../Ouroboros.Models.Brands.FirstName/index.js";
import * as Ouroboros_Models_Brands_LastName from "../Ouroboros.Models.Brands.LastName/index.js";
import * as Ouroboros_Models_Brands_OrganizationGoal from "../Ouroboros.Models.Brands.OrganizationGoal/index.js";
import * as Ouroboros_Models_Brands_OrganizationName from "../Ouroboros.Models.Brands.OrganizationName/index.js";
import * as Ouroboros_Models_Brands_Password from "../Ouroboros.Models.Brands.Password/index.js";
import * as Ouroboros_Models_Brands_PlanTier from "../Ouroboros.Models.Brands.PlanTier/index.js";
import * as Ouroboros_Models_Brands_UserZipcode from "../Ouroboros.Models.Brands.UserZipcode/index.js";
import * as Ouroboros_Models_Clients_OrganizationSignup from "../Ouroboros.Models.Clients.OrganizationSignup/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_TsBridgeHelpers from "../Ouroboros.Programs.TsBridgeHelpers/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
import * as Ouroboros_Services_Clients_Interop_Types from "../Ouroboros.Services.Clients.Interop.Types/index.js";
import * as Text_Email_Validate from "../Text.Email.Validate/index.js";
import * as TsBridge_Class from "../TsBridge.Class/index.js";
import * as TsBridge_DefaultImpls from "../TsBridge.DefaultImpls/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(TsBridge_Monad.bindTsBridgeM);
var tsBridge = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeIOts(/* #__PURE__ */ TsBridge_Class.tsBridgeRecord(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecord1()(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecordRLCons(/* #__PURE__ */ TsBridge_Class.tsBridgeByTok(TsBridge_Class.tsBridgeBoolean))(TsBridge_DefaultImpls.tsBridgeRecordRLNil)({
    reflectSymbol: function () {
        return "success";
    }
})))));
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var CreateAccountAction = function (x) {
    return x;
};
var tsBridgeCreateAccountActi = {
    tsBridge: function (v) {
        return bind(tsBridge(Type_Proxy["Proxy"].value))(function (valueType) {
            return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("CreateAccountAction")("__brandCreateAccountAction"));
        });
    }
};
var setFormError = function (env) {
    return function (message) {
        return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(env.form.formError))(Ouroboros_Services_Clients_Interop_Option.some(message));
    };
};
var runLoadingAction = function (v) {
    return v;
};
var runCreateAccountAction = function (v) {
    return v;
};
var requiresSquareBilling = function (planTier) {
    var tier = Ouroboros_Models_Brands_PlanTier.unwrap(planTier);
    return tier === "PayAsYouGo" || (tier === "Standard" || tier === "Enterprise");
};
var readState = function (v) {
    return v;
};
var validateStep = function (env) {
    return function (stepIndex) {
        var $42 = stepIndex === 0;
        if ($42) {
            var password = readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.form.password));
            var lastName = readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.form.lastName));
            var isBlank = function (value) {
                return Data_String_Common.trim(value) === "";
            };
            var firstName = readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.form.firstName));
            var email = Data_String_Common.trim(readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.form.email)));
            var confirmPassword = readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.form.confirmPassword));
            var $43 = isBlank(firstName) || isBlank(lastName);
            if ($43) {
                return Ouroboros_Services_Clients_Interop_Option.some("Please enter your first and last name.");
            };
            var $44 = !Text_Email_Validate.isValid(email);
            if ($44) {
                return Ouroboros_Services_Clients_Interop_Option.some("Please enter a valid email address.");
            };
            var $45 = Data_String_CodePoints.length(password) < 8;
            if ($45) {
                return Ouroboros_Services_Clients_Interop_Option.some("Password should be at least 8 characters.");
            };
            var $46 = password !== confirmPassword;
            if ($46) {
                return Ouroboros_Services_Clients_Interop_Option.some("Passwords do not match.");
            };
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        };
        var $47 = stepIndex === 1;
        if ($47) {
            var organizationName = readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.form.organizationName));
            var $48 = Data_String_Common.trim(organizationName) === "";
            if ($48) {
                return Ouroboros_Services_Clients_Interop_Option.some("Organization name is required.");
            };
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        };
        var $49 = stepIndex === 2;
        if ($49) {
            var planTier = readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.form.planTier));
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return Ouroboros_Services_Clients_Interop_Option.some("Select a plan tier to continue.");
            })(function (v) {
                return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
            })(planTier);
        };
        var $50 = stepIndex === 3;
        if ($50) {
            var squareBilling = readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.form.squareBilling));
            var planTier = readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.form.planTier));
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return Ouroboros_Services_Clients_Interop_Option.some("Select a plan tier to continue.");
            })(function (tier) {
                var $51 = requiresSquareBilling(tier);
                if ($51) {
                    return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                        return Ouroboros_Services_Clients_Interop_Option.some("Complete Square billing to continue.");
                    })(function (v) {
                        return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
                    })(squareBilling);
                };
                return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
            })(planTier);
        };
        return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
    };
};
var nonBlankOption = /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.chain(function (value) {
    var trimmed = Data_String_Common.trim(value);
    var $52 = trimmed === "";
    if ($52) {
        return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
    };
    return Ouroboros_Services_Clients_Interop_Option.some(trimmed);
});
var mkCreateAccountAction = CreateAccountAction;
var mapSignupSquareBilling = function (email) {
    return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
        return Data_Maybe.Nothing.value;
    })(function (squareBilling) {
        return new Data_Maybe.Just({
            card: {
                sourceId: Data_String_Common.trim(squareBilling.card.sourceId),
                verificationToken: Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                    return Data_Maybe.Nothing.value;
                })(function ($55) {
                    return Data_Maybe.Just.create(Ouroboros_Models_Clients_OrganizationSignup.OrganizationSignupSquareVerificationToken(Data_String_Common.trim($55)));
                })(nonBlankOption(squareBilling.card.verificationToken))
            },
            billingContact: {
                givenName: Ouroboros_Models_Brands_FirstName.makeFirstName(Data_String_Common.trim(squareBilling.billingContact.givenName)),
                familyName: Ouroboros_Models_Brands_LastName.makeLastName(Data_String_Common.trim(squareBilling.billingContact.familyName)),
                email: Ouroboros_Models_Brands_Email.makeEmail(Data_String_Common.trim(email)),
                phone: Data_String_Common.trim(squareBilling.billingContact.phone),
                addressLine1: Data_String_Common.trim(squareBilling.billingContact.addressLine1),
                addressLine2: Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                    return Data_Maybe.Nothing.value;
                })(function ($56) {
                    return Data_Maybe.Just.create(Ouroboros_Models_Clients_OrganizationSignup.OrganizationSignupSquareAddressLine($56));
                })(nonBlankOption(squareBilling.billingContact.addressLine2)),
                city: Data_String_Common.trim(squareBilling.billingContact.city),
                region: Data_String_Common.trim(squareBilling.billingContact.region),
                country: Data_String_Common.trim(squareBilling.billingContact.country),
                postalCode: Ouroboros_Models_Brands_UserZipcode.makeUserZipcode(Data_String_Common.trim(squareBilling.billingContact.postalCode))
            }
        });
    });
};
var formatSignupError = function (errorValue) {
    var message = Ouroboros_Models_Brands_ErrorMessageText.unwrap(errorValue.message);
    var fallback = (function () {
        if (errorValue.type === "Conflict") {
            return "Account or organization already exists.";
        };
        if (errorValue.type === "BadRequest") {
            return "Please review your signup details.";
        };
        return "Something went wrong. Please try again.";
    })();
    var finalMessage = (function () {
        var $54 = message === "";
        if ($54) {
            return fallback;
        };
        return message;
    })();
    return Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(finalMessage);
};
var toLoadingErrorInput = function (errorValue) {
    return {
        message: formatSignupError(errorValue),
        info: Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
    };
};
var handleSignupError = function (env) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(toLoadingErrorInput(errorValue))));
    };
};
var submitOrganization = function (env) {
    return function (request) {
        return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleSignupError(env))(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v1) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.form.signupComplete))(true));
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setSuccess)));
        })(env.signup.client.signup(request));
    };
};
var submitOrganizationTask = function (env) {
    return function (maybeRequest) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(setFormError(env)("Select a plan tier to continue."));
        })(function (request) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                return submitOrganization(env)(request);
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
        })(maybeRequest);
    };
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/create_account_controller.md";
var clearFormError = function (env) {
    return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(env.form.formError))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit));
};
var handleBack = function (env) {
    return function (stepBack) {
        return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ clearFormError(env), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.form.step))(stepBack) ]);
    };
};
var handleNext = function (env) {
    return function (stepIndex) {
        return function (stepNext) {
            var error = validateStep(env)(stepIndex);
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ clearFormError(env), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.form.step))(stepNext) ]);
            })(function (message) {
                return setFormError(env)(message);
            })(error);
        };
    };
};
var resetToChoice = function (env) {
    return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.form.mode))("choose"), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.form.step))(0), clearFormError(env) ]);
};
var buildSignupRequest = function (env) {
    var squareBilling = readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.form.squareBilling));
    var planTier = readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.form.planTier));
    var password = readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.form.password));
    var organizationName = readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.form.organizationName));
    var lastName = readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.form.lastName));
    var goals = readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.form.goals));
    var firstName = readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.form.firstName));
    var email = Data_String_Common.trim(readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.form.email)));
    return Ouroboros_Services_Clients_Interop_Option.map(function (tier) {
        return {
            email: Ouroboros_Models_Brands_Email.makeEmail(email),
            firstName: Ouroboros_Models_Brands_FirstName.makeFirstName(Data_String_Common.trim(firstName)),
            lastName: Ouroboros_Models_Brands_LastName.makeLastName(Data_String_Common.trim(lastName)),
            password: Ouroboros_Models_Brands_Password.makePassword(password),
            organizationName: Ouroboros_Models_Brands_OrganizationName.makeOrganizationName(Data_String_Common.trim(organizationName)),
            planTier: tier,
            goals: map(Ouroboros_Models_Brands_OrganizationGoal.makeOrganizationGoal)(goals),
            squareBilling: mapSignupSquareBilling(email)(squareBilling)
        };
    })(planTier);
};
var handleSubmit = function (env) {
    return function (stepIndex) {
        var request = buildSignupRequest(env);
        var error = validateStep(env)(stepIndex);
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ clearFormError(env), Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(submitOrganizationTask(env)(request)) ]);
        })(function (message) {
            return setFormError(env)(message);
        })(error);
    };
};
var mkCreateAccountController = function (env) {
    return {
        onOrganizationSignup: function (maybeRequest) {
            return mkCreateAccountAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(submitOrganizationTask(env)(maybeRequest)));
        },
        onProceedToApp: function (payload) {
            return mkCreateAccountAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(Ouroboros_Programs_Capabilities.runTaskHandler(env.proceedToApp)(payload)));
        },
        onNavigateToLogin: mkCreateAccountAction(Ouroboros_Programs_Capabilities.runControllerAction(Ouroboros_Programs_Capabilities.runNavigateAction(env.navigation.navigate)(env.navigation.loginRoute))),
        onResetToChoice: mkCreateAccountAction(resetToChoice(env)),
        onHandleNext: function (stepIndex) {
            return function (stepNext) {
                return mkCreateAccountAction(handleNext(env)(stepIndex)(stepNext));
            };
        },
        onHandleBack: function (stepBack) {
            return mkCreateAccountAction(handleBack(env)(stepBack));
        },
        onHandleSubmit: function (stepIndex) {
            return mkCreateAccountAction(handleSubmit(env)(stepIndex));
        }
    };
};
export {
    CreateAccountAction,
    mkCreateAccountController,
    runCreateAccountAction,
    documentationPath,
    tsBridgeCreateAccountActi
};
//# sourceMappingURL=index.js.map
